// Document Module Page - Uses generic module initialization patterns
// Demonstrates the streamlined approach for creating module pages

import { createModulePage } from '../../../components/generic/createModulePage';
import { initializeModule } from '../../../utils/configInit';
import { documentModuleConfig } from './documentModuleConfig';
import { createDocumentModuleValidation } from './documentModuleValidation';
// DocumentModuleService no longer needed - using SWR hooks directly

/**
 * Initialize the document module using generic utilities
 * This pattern eliminates the need for separate initialization files
 */
const { config: initializedConfig } = initializeModule(
  documentModuleConfig,
  createDocumentModuleValidation
);

/**
 * Create the DocumentModulePage using the generic module page factory
 * This eliminates the need for custom component wrappers
 */
const DocumentModulePage = createModulePage(
  initializedConfig,
  {
    displayName: 'DocumentModulePage',
    description: 'Document Module Management System - Manage document module assignments'
  }
);

export default DocumentModulePage;

